<div class="sidebar-nav">
  <div class="sidebar-nav-items">
    <div class="sidebar-nav-loading" *ngIf="isLoading; else maincontent">
      <app-loading-dots size="4px"></app-loading-dots>
    </div>

    <ng-template #maincontent>
      <ng-container *ngFor="let button of menuItems; let i = index">
        <div
          *ngIf="hasVisibleChildren(button) || isCoursesItem(button)"
          class="nav-item-group"
          [class.courses-nav-group]="isCoursesItem(button)"
          [class.courses-nav-group-no-children]="
            isCoursesItem(button) &&
            !hasVisibleChildren(button) &&
            !button.loadingChildren
          "
          [class.expanded]="isExpanded(button)"
          [class.child-active]="isChildActive(button)">
          <a
            *ngIf="hasVisibleChildren(button)"
            class="left-menu-button nav-item nav-item-parent"
            [class.parent-active]="isParentRouteActive(button)"
            href="#"
            tourTarget
            [tourId]="button.tourId"
            [stepId]="button.stepId"
            [tourPosition]="button.position"
            (click)="onNavItemClick(button, $event)"
            [attr.tabindex]="getTabIndex(button)"
            [style.animation-delay]="i * 50 + 'ms'"
            [pTooltip]="button.translation_key || button.title | translation"
            tooltipPosition="right"
            [tooltipDisabled]="!isCollapsed || hoveredParent === button"
            (mouseenter)="onParentMouseEnter(button, $event)"
            (mouseleave)="onParentMouseLeave()">
            <ng-container
              *ngTemplateOutlet="
                parentNavBody;
                context: { button: button }
              "></ng-container>
          </a>
          <a
            *ngIf="!hasVisibleChildren(button)"
            class="left-menu-button nav-item nav-item-parent"
            [class.parent-active]="isParentRouteActive(button)"
            [routerLink]="button.link"
            tourTarget
            [tourId]="button.tourId"
            [stepId]="button.stepId"
            [tourPosition]="button.position"
            (click)="onNavItemClick(button, $event)"
            [attr.tabindex]="getTabIndex(button)"
            [style.animation-delay]="i * 50 + 'ms'"
            [pTooltip]="button.translation_key || button.title | translation"
            tooltipPosition="right"
            [tooltipDisabled]="!isCollapsed || hoveredParent === button"
            (mouseenter)="onParentMouseEnter(button, $event)"
            (mouseleave)="onParentMouseLeave()">
            <ng-container
              *ngTemplateOutlet="
                parentNavBody;
                context: { button: button }
              "></ng-container>
          </a>

          <div
            class="nav-children"
            *ngIf="
              (isExpanded(button) ||
                (isCollapsed &&
                  (isChildActive(button) || isParentRouteActive(button))) ||
                button.loadingChildren) &&
              (hasVisibleChildren(button) || button.loadingChildren)
            ">
            <div class="nav-children-loading" *ngIf="button.loadingChildren">
              <app-loading-dots size="3px"></app-loading-dots>
            </div>
            <ng-container *ngIf="!button.loadingChildren">
              <a
                *ngFor="let child of getVisibleChildren(button)"
                class="left-menu-button nav-item nav-item-child"
                [routerLink]="child.link"
                routerLinkActive="left-menu-button-active"
                tourTarget
                [tourId]="child.tourId"
                [stepId]="child.stepId"
                [tourPosition]="child.position"
                (click)="tourService.nextStep(child.tourId, child.stepId)"
                [pTooltip]="child.translation_key || child.title | translation"
                tooltipPosition="right"
                [tooltipDisabled]="!isCollapsed">
                <span class="nav-item-indicator"></span>
                <div class="left-menu-button-label">
                  <div class="nav-icon-wrapper" *ngIf="child.icon">
                    <i [class]="child.icon"></i>
                  </div>
                  <div
                    class="nav-icon-wrapper nav-icon-placeholder"
                    *ngIf="!child.icon"></div>
                  <div class="nav-label">
                    {{ child.translation_key || child.title | translation }}
                  </div>
                </div>
              </a>
            </ng-container>
          </div>
        </div>

        <a
          *ngIf="!hasVisibleChildren(button) && !isCoursesItem(button)"
          class="left-menu-button nav-item"
          routerLinkActive="left-menu-button-active"
          [routerLink]="button.link"
          tourTarget
          [tourId]="button.tourId"
          [stepId]="button.stepId"
          [tourPosition]="button.position"
          (click)="onNavItemClick(button, $event)"
          [attr.tabindex]="getTabIndex(button)"
          [style.animation-delay]="i * 50 + 'ms'"
          [pTooltip]="button.translation_key || button.title | translation"
          tooltipPosition="right"
          [tooltipDisabled]="!isCollapsed">
          <span class="nav-item-indicator"></span>
          <p-overlayBadge
            badgeSize="small"
            [value]="badgeValue"
            severity="warn"
            *ngIf="button.badge && (button.badge() | async) as badgeValue"
            class="nav-badge"></p-overlayBadge>
          <div class="left-menu-button-label">
            <div class="nav-icon-wrapper">
              <i [class]="button.icon"></i>
            </div>
            <div class="nav-label">
              {{ button.translation_key || button.title | translation }}
            </div>
          </div>
        </a>
      </ng-container>
    </ng-template>
  </div>

  <div class="sidebar-footer">
    <div class="product-feature-section">
      <app-scaffold-type
        [selected]="selectedType"
        (changed)="onInstanceChange($event)"
        label="Product:"></app-scaffold-type>
      <div *ngIf="features.length > 1" class="feature-select-wrapper">
        <p-select
          [options]="features"
          [(ngModel)]="activeFeature"
          (onChange)="onFeatureChange($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Feature"
          appendTo="body">
          <ng-template #selectedItem let-selectedOption>
            {{
              selectedOption?.value === 'archivev2'
                ? 'Archiving'
                : selectedOption?.label
            }}
          </ng-template>
          <ng-template let-opt #item>
            {{ opt?.value === 'archivev2' ? 'Archiving' : opt?.label }}
          </ng-template>
        </p-select>

        <div class="footer-divider"></div>
      </div>
    </div>

    <ng-container *ngFor="let menuItem of footerItems">
      <ng-container [ngSwitch]="menuItem.type">
        <a
          *ngSwitchCase="'link'"
          class="left-menu-button nav-item footer-nav-item"
          [routerLink]="menuItem.link"
          routerLinkActive="left-menu-button-active"
          [pTooltip]="menuItem.translation_key || menuItem.title | translation"
          tooltipPosition="right"
          [tooltipDisabled]="!isCollapsed">
          <span class="nav-item-indicator"></span>
          <div class="left-menu-button-label">
            <div class="nav-icon-wrapper">
              <i [ngClass]="menuItem.icon"></i>
            </div>
            <div class="nav-label">
              {{ menuItem.translation_key || menuItem.title | translation }}
            </div>
          </div>
        </a>
        <a
          *ngSwitchCase="'modal'"
          class="left-menu-button nav-item footer-nav-item"
          (click)="onFooterModalClick(menuItem.modal)"
          [pTooltip]="menuItem.translation_key || menuItem.title | translation"
          tooltipPosition="right"
          [tooltipDisabled]="!isCollapsed">
          <span class="nav-item-indicator"></span>
          <div class="left-menu-button-label">
            <div class="nav-icon-wrapper">
              <i [ngClass]="menuItem.icon"></i>
            </div>
            <div class="nav-label">
              {{ menuItem.translation_key || menuItem.title | translation }}
            </div>
          </div>
        </a>
        <a
          *ngSwitchCase="'url'"
          class="left-menu-button nav-item footer-nav-item footer-nav-item-external"
          [href]="menuItem.url"
          target="_blank"
          [pTooltip]="menuItem.translation_key || menuItem.title | translation"
          tooltipPosition="right"
          [tooltipDisabled]="!isCollapsed">
          <span class="nav-item-indicator"></span>
          <div class="left-menu-button-label">
            <div class="nav-icon-wrapper">
              <i [ngClass]="menuItem.icon"></i>
            </div>
            <div class="nav-label">
              {{ menuItem.translation_key || menuItem.title | translation }}
            </div>
            <i class="fas fa-external-link-alt external-icon"></i>
          </div>
        </a>
      </ng-container>
    </ng-container>

    <div class="system-type-section" *ngIf="allowSystemSwitch">
      <label class="system-type-label">LMS:</label>
      <p-select
        [options]="systemTypeOptions"
        [(ngModel)]="selectedSystemType"
        (onChange)="onSystemTypeChange($event)"
        optionLabel="label"
        optionValue="value"
        placeholder="Select LMS"
        appendTo="body">
      </p-select>
    </div>
  </div>
</div>

<div
  *ngIf="isCollapsed && hoveredParent"
  class="sidebar-nav-flyout"
  [style.top.px]="flyoutTop"
  (mouseenter)="onFlyoutMouseEnter()"
  (mouseleave)="onFlyoutMouseLeave()">
  <div class="sidebar-nav-flyout-title">
    {{ hoveredParent.translation_key || hoveredParent.title | translation }}
  </div>
  <nav class="sidebar-nav-flyout-list">
    <div
      class="sidebar-nav-flyout-loading"
      *ngIf="hoveredParent.loadingChildren">
      <app-loading-dots size="3px"></app-loading-dots>
    </div>
    <a
      *ngFor="let child of getVisibleChildren(hoveredParent)"
      class="sidebar-nav-flyout-item"
      [routerLink]="child.link"
      routerLinkActive="sidebar-nav-flyout-item-active">
      <span class="sidebar-nav-flyout-item-icon" *ngIf="child.icon">
        <i [class]="child.icon"></i>
      </span>
      <span
        class="sidebar-nav-flyout-item-icon sidebar-nav-flyout-item-icon-placeholder"
        *ngIf="!child.icon"></span>
      <span class="sidebar-nav-flyout-item-label">
        {{ child.translation_key || child.title | translation }}
      </span>
    </a>
  </nav>
</div>

<ng-template #parentNavBody let-button="button">
  <span class="nav-item-indicator"></span>
  <p-overlayBadge
    badgeSize="small"
    [value]="badgeValue"
    severity="warn"
    *ngIf="button.badge && (button.badge() | async) as badgeValue"
    class="nav-badge"></p-overlayBadge>
  <div class="left-menu-button-label">
    <div class="nav-icon-wrapper">
      <i [class]="button.icon"></i>
    </div>
    <div class="nav-label">
      {{ button.translation_key || button.title | translation }}
    </div>
  </div>
  <button
    *ngIf="
      !isCoursesItem(button) ||
      hasVisibleChildren(button) ||
      button.loadingChildren
    "
    class="nav-expand-btn"
    (click)="toggleExpand(button, $event)"
    [attr.aria-expanded]="isExpanded(button)"
    aria-label="Toggle submenu"
    type="button">
    <i class="fas fa-chevron-down"></i>
  </button>
</ng-template>
